import { MoreVertical } from 'lucide-react'
import type { JSX } from 'react/jsx-runtime'
import { useNavigate } from 'react-router-dom'
import { routes } from '@/common/constants/routes'
import { ModeToggle } from '@/components/shared/mode-toggle'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Button } from '@/components/ui/button'
import { SidebarTrigger } from '@/components/ui/sidebar'

export const Header = (): JSX.Element => {
  const navigate = useNavigate()

  return (
    <header
      className="
        sticky top-0 z-20 flex h-16 shrink-0 items-center border-b
        border-gray-200 bg-white/80 px-4 py-3 backdrop-blur-md
        dark:border-gray-800 dark:bg-gray-900/80
      "
    >
      <div className="flex w-full items-center justify-between">
        <SidebarTrigger className="-ml-1" />

        <div className="flex-1 text-center">
          <h1
            className="
              font-bold text-gray-900
              dark:text-gray-100
            "
          >
            Vakeel Near Me
          </h1>
          <p
            className="
              text-[10px] text-gray-400
              dark:text-gray-500
            "
          >
            वकील नियर मी
          </p>
        </div>

        <div className="flex items-center gap-2">
          <ModeToggle />
          <Button
            size="icon"
            variant="ghost"
            className="
              rounded-full bg-teal-50
              hover:bg-teal-100
              dark:bg-teal-900/30
              dark:hover:bg-teal-900/50
            "
            onClick={() => void navigate(routes.PROFILE)}
          >
            <Avatar
              className="
                size-8 cursor-pointer transition-opacity
                hover:opacity-80
              "
            >
              <AvatarFallback className="
                bg-teal-500 text-xs font-bold text-white
              ">
                S
              </AvatarFallback>
            </Avatar>
          </Button>
          <button
            className="
              -mr-2 rounded-lg p-2 transition-colors
              hover:bg-gray-100
              dark:hover:bg-gray-700
            "
          >
            <MoreVertical
              className="
                size-5 text-gray-700
                dark:text-gray-300
              "
            />
          </button>
        </div>
      </div>
    </header>
  )
}
